import React from 'react';
import { useIntl } from 'react-intl';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faXmark } from '@fortawesome/pro-light-svg-icons/faXmark';
import { TypedMemo } from '../../common/types';
import styles from './EmbedSheetHeader.module.scss';

interface EmbedSheetHeaderProps {
  /** The page, and the artist when the account has a name. */
  subject: string;
  onClose: () => void;
}

/** The header. The close sits in it, rather than floating over the preview. */
const EmbedSheetHeaderComponent: React.FC<EmbedSheetHeaderProps> = ({ subject, onClose }) => {
  const intl = useIntl();

  return (
    <div className={styles.strip}>
      <div className={styles.text}>
        <h2 className={styles.title}>
          {intl.formatMessage({ id: 'app.sml.embed.title', defaultMessage: 'Embed this smart link' })}
        </h2>
        <span className={styles.subject} title={subject}>
          {subject}
        </span>
      </div>
      <button
        type="button"
        className={styles.close}
        onClick={onClose}
        aria-label={intl.formatMessage({ id: 'app.sml.embed.close', defaultMessage: 'Close' })}
      >
        <FontAwesomeIcon icon={faXmark} />
      </button>
    </div>
  );
};

export const EmbedSheetHeader = TypedMemo(EmbedSheetHeaderComponent);
